import { render } from "./CashSettlement.vue?vue&type=template&id=381a7860&scoped=true"
import script from "./CashSettlement.vue?vue&type=script&lang=js"
export * from "./CashSettlement.vue?vue&type=script&lang=js"

import "./CashSettlement.vue?vue&type=style&index=0&id=381a7860&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-381a7860"]])

export default __exports__